import { createSelector } from '@ngrx/store';

import { locationsFiltersState } from '../root';

export const getLocationFiltersGeocoder = createSelector(locationsFiltersState, (locationsFilters) => locationsFilters?.geocoder || null);
